import IAuthState from "../models/IAuthState";

export const initialState: IAuthState = {
    token: '',
    userId: 0,
    userType: -1,
    error: null,
    loading: false,
    userName: '',
    userEmail: ''
}